import { MctcTableModeService } from './table-mode.service';
import { BehaviorSubject, take } from 'rxjs';
import { PfmV2Service } from '../../../../shared/services/base/pfm-v2.service';
import { Injectable, inject } from "@angular/core";
import { UserPreferencesService } from '../../../services/user-preferences.service';
import { managePageUserPreferenceStrings } from "../../../constants/user-preferences.constants";
import { Budget } from '../../../../shared/types/budget.interface';
import ManageCegTableContainerStore from '../manage-ceg-table-container.store';

// CURRENTLY THIS SEVRICE IS STRICTLY  HANDLING THE TABLE API CALLS
@Injectable({
  providedIn: 'root'
})
export class MctcApiService {
  private api_v2_manager = inject(PfmV2Service);
  private userPreferencesService = inject(UserPreferencesService);
  private readonly mctctTableModeService = inject(MctcTableModeService);
  private urls = {
    getManagePageFields: () => `managepage_fields/`
  }

  // This is the master data with following dependents:
  // 1. Budget Table Config
  // 2. Table columns (CAB)
  public getManagePageFields(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.api_v2_manager.get(
        this.urls.getManagePageFields(), {}
      ).subscribe({
        next: (response) => {
          ManageCegTableContainerStore.managePageFields = response;
          resolve(response);
        },
        error: (error) => {
          console.log('Error fetching manage page fields:', error);
          reject();
        }
      });
    });
  }

  public fetchDependentData(budget: Budget): Promise<any> {
    const budgetTableAreaDetails = managePageUserPreferenceStrings['budget_table'].personalization_keys;
    const personalizationKeys = [
      budgetTableAreaDetails.table_config,
      budgetTableAreaDetails.timeframe_config
    ];
    return new Promise((resolve, reject) => {
      // NOTE: Resolve promise inside forkJoin (if other subscriptions are needed)
      this.userPreferencesService.getUserPersonalizationDataConfig(
        budget.company.toString(),
        budget.id.toString(),
        managePageUserPreferenceStrings['budget_table'].name,
        personalizationKeys
      ).pipe(take(1)).subscribe({
        next: (response) => {
          response = this.mctctTableModeService.handleApiResponse(budget, response);
          resolve(response);
        },
        error: (error) => {
          console.error('Error fetching user personalization data:', error);
          reject();
        }
      });
    });
  }
}
